import { Checkbox } from 'components/tailwind-ui/Checkbox';
import * as React from 'react';
import { Profile } from 'types/User';

interface Props {
  profile: Profile | null;
  onChange: (profile: Profile | null, checked: boolean) => void;
  checked: boolean;
}

export const Member: React.FC<Props> = (props) => {
  const { profile, onChange, checked } = props;
  return (
    <Checkbox
      id={`deleted-by-filter-${profile?.id}`}
      onCheck={(c) => onChange(profile, c)}
      checked={checked}
      className="px-3 py-2 hover:bg-blue-200"
      label={
        <div className="overflow-hidden text-ellipsis max-w-[300px]">
          {profile
            ? `${profile.first_name} ${profile.last_name} (${profile.email})`
            : 'Deleted user'}
        </div>
      }
    />
  );
};
Member.displayName = 'Shipments.DeletedContainers.ActionBar.DeletedBy.Member';
